import React, { PropTypes } from "react";

export default function CouponView({ value, labels, onChange, onAdd }) {
    return (
      <tbody>
        <tr>
          <td>{labels.title}</td>
          <td colSpan="3">
            <input
              type="text"
              id="couponCode"
              className="form-control"
              value={value || ""}
              onChange={event => onChange(event.target.value)}
            />
          </td>
          <td colSpan="3">
            <button
              className="btn btn-outline-primary"
              disabled={value === null || value.length === 0}
              onClick={(event) => {
                  event.preventDefault();
                  onAdd();
              }}
            >{labels.add_coupon}</button>
          </td>
        </tr>
      </tbody>
    );
}

CouponView.propTypes = {
    value: PropTypes.string,
    labels: PropTypes.shape({
        add_coupon: PropTypes.string,
    }).isRequired,
    onAdd: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};


CouponView.defaultProps = {
    value: "",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Views/CouponView.jsx